/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectGameTypeQueryVariables = {|
  sportId: string
|};
export type SelectGameTypeQueryResponse = {|
  +activeGameTypesForSport: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
    +gametypelineupsetSet: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +lineupSet: {|
            +lineuprosterslotSet: {|
              +edges: $ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +rosterSlot: {|
                    +name: string
                  |},
                  +order: number,
                  +amount: number,
                  +selectable: boolean,
                |}
              |}>
            |}
          |}
        |}
      |}>
    |},
  |}>
|};
export type SelectGameTypeQuery = {|
  variables: SelectGameTypeQueryVariables,
  response: SelectGameTypeQueryResponse,
|};
*/


/*
query SelectGameTypeQuery(
  $sportId: ID!
) {
  activeGameTypesForSport(sportId: $sportId) {
    id
    name
    gametypelineupsetSet {
      edges {
        node {
          lineupSet {
            lineuprosterslotSet {
              edges {
                node {
                  id
                  rosterSlot {
                    name
                    id
                  }
                  order
                  amount
                  selectable
                }
              }
            }
            id
          }
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sportId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "sportId",
    "variableName": "sportId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectable",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectGameTypeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GameTypeType",
        "kind": "LinkedField",
        "name": "activeGameTypesForSport",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GameTypeLineupSetTypeConnection",
            "kind": "LinkedField",
            "name": "gametypelineupsetSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GameTypeLineupSetTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameTypeLineupSetType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LineupSetType",
                        "kind": "LinkedField",
                        "name": "lineupSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LineupRosterSlotTypeConnection",
                            "kind": "LinkedField",
                            "name": "lineuprosterslotSet",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LineupRosterSlotTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineupRosterSlotType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RosterSlotType",
                                        "kind": "LinkedField",
                                        "name": "rosterSlot",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelectGameTypeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GameTypeType",
        "kind": "LinkedField",
        "name": "activeGameTypesForSport",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GameTypeLineupSetTypeConnection",
            "kind": "LinkedField",
            "name": "gametypelineupsetSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GameTypeLineupSetTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameTypeLineupSetType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LineupSetType",
                        "kind": "LinkedField",
                        "name": "lineupSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LineupRosterSlotTypeConnection",
                            "kind": "LinkedField",
                            "name": "lineuprosterslotSet",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LineupRosterSlotTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineupRosterSlotType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RosterSlotType",
                                        "kind": "LinkedField",
                                        "name": "rosterSlot",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2afbed91f9f9856da15cca4f2843ae88",
    "id": null,
    "metadata": {},
    "name": "SelectGameTypeQuery",
    "operationKind": "query",
    "text": "query SelectGameTypeQuery(\n  $sportId: ID!\n) {\n  activeGameTypesForSport(sportId: $sportId) {\n    id\n    name\n    gametypelineupsetSet {\n      edges {\n        node {\n          lineupSet {\n            lineuprosterslotSet {\n              edges {\n                node {\n                  id\n                  rosterSlot {\n                    name\n                    id\n                  }\n                  order\n                  amount\n                  selectable\n                }\n              }\n            }\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6861975048be5661f7d245fcf4580194';

module.exports = node;
